import { Flex, Text } from '@chakra-ui/react';
import { FormFeedback, OutlineCard, Radio } from '@morressier/alembic';
import { FormFieldRadio } from '@publishing-engine/domain/types/article';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { get } from 'lodash';
import asDependentFieldComponent from './asDependentFieldComponent';

const RadioGroup = ({
  config
}: {
  config:
    | FormFieldRadio<'preference.openAccessChoice'>
    | FormFieldRadio<'preference.dataUnavailabilityReason'>
    | FormFieldRadio<'preference.coAuthorApproval'>
    | null;
}) => {
  const {
    formState: { errors },
    register
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main }
  } = config!;
  const error = get(errors, main);

  return (
    <OutlineCard padding={4} width="100%">
      <Flex flexDirection="column" gap={4} width="100%">
        <FieldLabel
          isRequired={validations.required}
          label={labels.main}
          subText={labels.subtitle}
          helpText={labels.helpText}
        />
        <Flex flexDirection="column">
          {validations.options.map(key => (
            <Radio
              key={key}
              {...register(main)}
              value={key}
              ariaLabel={key}
              id={key}
            >
              <Flex flexDirection="column">
                <Text textStyle="headingItem">{labels.options[key]?.main}</Text>
                <Text>{labels.options[key]?.secondary}</Text>
              </Flex>
            </Radio>
          ))}

          {error ? (
            <FormFeedback variant="error">
              Select {labels.main} to proceed.
            </FormFeedback>
          ) : null}
        </Flex>
      </Flex>
    </OutlineCard>
  );
};

export default asDependentFieldComponent(RadioGroup);
